import React from 'react';

interface NotificationBadgeProps {
  count: number;
  maxCount?: number;
  size?: 'sm' | 'md';
  className?: string;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  count,
  maxCount = 99,
  size = 'sm',
  className,
}) => {
  if (count <= 0) return null;

  const displayCount = count > maxCount ? `${maxCount}+` : count.toString();
  const dimensions =
    size === 'sm'
      ? 'min-w-[18px] h-[18px] text-[10px]'
      : 'min-w-[22px] h-[22px] text-[11px]';

  return (
    <span
      className={`inline-flex items-center justify-center ${dimensions} px-1 rounded-full bg-red-500 text-white font-semibold leading-none ${className || ''}`}
    >
      {displayCount}
    </span>
  );
};

export default NotificationBadge;
